
<template lang="html" >

    
       
        <div class="container-fluid">
            <div v-if="!showCitas">
                <altacitas :nrreporte="nrreporte" :svindice="svindice" :aiclave="aiclave" :ciid="ciid" :pantalla="pantalla" @cambio="cambio"></altacitas>
            </div>
            <div v-if="showCerrar">
                <cerrarcita :nrreporte="nrreporte" :svindice="svindice" :aiclave="aiclave" :ciid="ciid" @cambioCerrar="cambioCerrar"></cerrarcita>
            </div>
            <div v-if="showCancelar">
                <cancelarcita :nrreporte="nrreporte" :svindice="svindice" :aiclave="aiclave" :ciid="ciid" @cambioCancelar="cambioCancelar"></cancelarcita>
            </div>
            <v-row v-if="showCitas && !showCerrar && !showCancelar ">
                <v-col lg=12 cols=12 style="margin: 0 auto;">

                    <v-card>
                        <v-card-title class="pa-5 pb-3 primary">
                            <v-icon class="pr-4" :color="'#FFFFFF'">mdi-calendar-clock</v-icon>
                            <p style="color: white;">Historial de Citas</p>

                        </v-card-title>

                       

                        <v-card-text class="pa-1 pt-4">


                            <v-card-title>
                                <v-btn v-if="valConc==0"
                                       tile
                                       @click="altaCita"
                                       color="green">
                                    <v-icon left color="white">
                                        mdi-plus
                                    </v-icon>
                                    <span style='color: white;'>Agregar Cita</span>
                                </v-btn>
                            </v-card-title>
                            <v-col md="12">
                                <DataTable :url="urlListado" :columns="columns" :params="displayInputs" :formatterActions="formatterActions" :order="[[ 0, 'desc' ]]" @apiDT="apiDT = $event"></DataTable>
                            </v-col>
                        </v-card-text>

                    </v-card>
                </v-col>
            </v-row>


        </div>



</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import citas from '@/services/ControldeCitas/Citas.service.js';
    import altacitas from "@/components/pages/ControldeCitas/AltaCita.vue";
    import cerrarcita from "@/components/pages/ControldeCitas/CerrarCita.vue";
    import cancelarcita from "@/components/pages/ControldeCitas/CancelarCita.vue";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            altacitas,
            cerrarcita,
            cancelarcita,
            DataTable
        },
        data() {
            return {
                valConc:1,
                nrreporte:'',
                svindice: '',
                aiclave: '',
                search: '',
                show: true,
                showCitas: true,
                showCerrar: false,
                showCancelar:false,
                hcitas: [],
                pantalla: '',
                ciid: 0,

                urlListado: "ControldeCitas/ObtenerHistorialCitas",
                columns: [
                    { name: 'ciestatus', data: 'ciestatus', title: "Estatus", formatter: [this, "formatearEstatus"], orderable: false },
                    { name: 'cifhcita', data: 'cifhcita', title: "Fecha Inicio" },
                    { name: 'cifhfincita', data: 'cifhfincita', title: "Fecha Fin" },
                    { name: 'tpcnombre', data: 'tpcnombre', title: "Tipo Cita" },
                    { name: 'cicomentario', data: 'cicomentario', title: "Comentarios" },
                    { name: 'uslogin', data: 'uslogin', title: "Usuario" },
                    { name: 'uscoord', data: 'uscoord', title: "", formatter: [this, "formatearCheckIn"], orderable: false },
                    { name: "cancelar", data: "cancelar", title: "", formatter: [this, "formatearCancelar"], orderable: false },
                    { name: "editar", data: "editar", title: "", formatter: [this, "formatearEditar"], orderable: false },
                    { name: "cerrar", data: "cerrar", title: "", formatter: [this, "formatearCerrar"], orderable: false },

                ],
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0
                },
                formatterActions: [
                    { click: [this, "cancelarCitas"] },
                    { click: [this, "editCita"] },
                    { click: [this, "cerrarCitas"] }
                    
                ],
            }
        },

        computed: {
            ...mapState(['permission', 'domain']),
            ...mapState('Ci', ['key']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
            formatearEstatus(x) {
                if (x.ciestatus == 'V') {
                    return `<button style="background-color:` + x.icono + `; " type="button" class="mx-2 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small" title="` + x.textoicono + `"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-calendar-blank theme--dark" style="margin-right: -5px;"></i><i aria-hidden="true" class="v-icon notranslate mdi mdi-clock-outline theme--dark" style="font-size: 12px; margin-right: -20px; margin-bottom: -25px; background-color:` + x.coloriconoPequeno + `; border-radius: 50%;"></i><br></span></button>`;

                }
                else if (x.ciestatus == 'C') {
                    return `<button style="background-color:` + x.icono + `; " type="button" class="mx-2 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small" title="` + x.textoicono + `"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-calendar-blank theme--dark" style="margin-right: -5px;"></i><i aria-hidden="true" class="v-icon notranslate mdi mdi-clock-outline theme--dark" style="font-size: 12px; margin-right: -20px; margin-bottom: -25px; background-color:` + x.coloriconoPequeno + `; border-radius: 50%;"></i><br></span></button>`;

                }
                else if (x.ciestatus == 'X') {
                    return `<button style="background-color:` + x.icono + `; " type="button" class="mx-2 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small" title="` + x.textoicono + `"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-calendar-remove theme--dark"></i></span></button>`;
                }
                else {
                    return ``;
                }
                
                
            },
            formatearCheckIn(x) {
                if (x.uscoord != null && x.uscoord != '') {
                    let long = x.uscoord.split('|')[1];
                    let lat = x.uscoord.split('|')[0];
                    return `<a href="https://www.google.com/maps?q=${lat},${long}" target="_blank" class="btn-primary primary dt-formatterAction ma-1 v-btn theme--light v-size--small" title="Localizar"><span class="v-btn__content"><i aria-hidden="true" class="v-icon coloricon notranslate mdi mdi-map-marker-outline theme--light"></i></span></a>`;

                }
                else {
                    return ``;
                }
            },
            formatearEditar(x) {
                if (x.ciestatus == 'V' && x.dias <= 7 && x.permiso == 1 && x.Concluido == 0 && x.Diferencia > 0) {
                    return `<button type="button" data-action="1" data-params="${x}" class="dt-formatterAction ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small primary" title="Editar"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-pencil theme--light white--text"></i></span></button>`;

                }
                else {
                    return ``;
                }
            },
            formatearCancelar(x) {
                if (x.ciestatus == 'V' && x.dias <= 7 && x.permiso == 1 && x.Concluido == 0 ) {
                    return `<button type="button" data-action="0" data-params="${x}" class="dt-formatterAction ma-1 ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small red" title="Cancelar Cita"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-cancel theme--light white--text"></i></span></button>`;
                }
                else {
                    return ``;
                }
            },
            formatearCerrar(x) {
                
                if (x.ciestatus == 'V' && x.dias <= 7 && x.permiso == 1 && x.Concluido == 0 && x.Diferencia <= 0) {
                    return `<button type="button" data-action="2" data-params="${x}" class="dt-formatterAction ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small green" title="Cerrar Cita"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-clock-outline theme--light white--text"></i></span></button>` ;
                }
                else {
                    return ``;
                }
            },

            async cambioCerrar(valor) {

                this.showCerrar = valor;
                this.show = true;

            },
            async cambioCancelar(valor) {

                this.showCancelar = valor;
                this.show = true;

            },
            async cambio(valor) {
                this.showCitas = valor;

                this.show = true;

            },
            altaCita() {
                this.pantalla = 'A';
                this.showCitas = false;
                this.ciid = 0;
            },

            editCita(params, item, fila) {

                this.pantalla = 'E';
                this.ciid = item.ciid;
                this.showCitas = false;
            },
            cerrarCitas(params, item, fila) {
                this.ciid = item.ciid;
                this.showCerrar = true;
            },
            cancelarCitas(params, item, fila) {
                this.ciid = item.ciid;
                this.showCancelar = true;
            },
            getColor(estatus) {
                if (estatus == 'V') {
                    return 'green'
                }
                else if (estatus == 'C') {
                    return 'green'
                }
                else {
                    return 'red'
                }
            },
            getText(estatus) {
                if (estatus == 'V') {//Vigente
                    return 'green'
                }
                else if (estatus == 'C') {//cerrado
                    return 'Cerrado'
                }
                else {  //cancelado es X
                    return 'Cancelado'
                }
            }
        },
        async mounted() {

            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');

            this.displayInputs = {
                nrreporte: datos.nrreporte,
                svindice: datos.svindice
            };


            this.nrreporte = datos.nrreporte;
            this.svindice = datos.svindice;
            this.aiclave = datos.aiclave;
            citas.obtenervalConclusion(this);
        }
    }
</script>
<style>
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        font-size: 16px !important;
        color: black;
        font-weight: bold;
    }

    .coloricon{
        color: #ffffff !important;
    }
</style>
